import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('credit-processes-summary', storeModule.createStoreModule('credit-processes-summary'))
